import intlMessagesEN from "./i18n/localization/en.json";
import intlMessagesVi from "./i18n/localization/vi.json";
import initReducer from "./Store/initReducer";

export default {
  name: "Subject",
  dir: "Subject",
  pathRoot: "subject",
  routes: [
    {
      url: ":id",
      component: "Page/CreateEdit",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Cập nhật chủ đề | Trắc nghiệm toàn diện",
        titleI18n: "Subject:updateSubject",
      },
    },
    {
      url: "",
      component: "Page",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Chủ đề| Trắc nghiệm toàn diện",
        titleI18n: "Subject:titleSubject",
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
  redux: initReducer,
  role: ["quickquiZFullRole", "CTV"],
};
